<!-- 企业认证功能项 -->
<template>
	<div style="width: 740px;height: 100%;">
		<div class="auth-content">
			<p class="tip-text">请选择一种方式验证您与企业的关系</p>
			<p class="company-info">
				当前认证公司：<span style="cursor:pointer;">{{companyName}}</span>
				<img src="./assets/img/edit.png" style="vertical-align: bottom;margin-left: 10px;" @click="open" />
			</p>
			<el-radio-group style="width: 100%" v-model="selectedAuth">
				<div style="background-color: white;display: flex;align-items: center;border-radius: 10px;">
					<div class="option-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="34" height="28" viewBox="0 0 34 28" fill="none">
  <path d="M30.332 0.666992C32.1654 0.666992 33.666 2.16668 33.666 4V24C33.666 25.8333 32.1654 27.333 30.332 27.333H3.66602C1.83268 27.333 0.332031 25.8333 0.332031 24V4C0.332049 2.16668 1.83269 0.666992 3.66602 0.666992H30.332ZM19.249 14.25C19.0824 14 18.7487 14 18.582 14.25L16.166 18.333C16.0827 18.583 16.249 18.833 16.499 18.833L19.166 18.583C19.3324 18.583 19.4158 18.5835 19.499 18.75L20.666 21.167C20.7496 21.4165 21.0824 21.4167 21.249 21.167L23.416 17.5C23.5823 17.3334 23.4157 17.0003 23.166 17C21.4994 16.75 19.999 15.75 19.249 14.25ZM29.082 14.333C28.9154 14.0835 28.5827 14.0835 28.416 14.333C27.5827 15.7496 26.1658 16.8332 24.416 17C24.166 17 23.9993 17.25 24.166 17.5L26.332 21.167C26.4987 21.4168 26.8326 21.4168 26.916 21.167L28.082 18.75C28.1654 18.6667 28.2493 18.583 28.416 18.583L31.082 18.833C31.332 18.833 31.5827 18.583 31.416 18.333L29.082 14.333ZM5.33203 17.833C4.66549 17.8331 4.16602 18.3334 4.16602 19C4.16603 19.6666 4.66551 20.1669 5.33203 20.167H12.832C13.4987 20.167 13.999 19.6667 13.999 19C13.999 18.3333 13.4987 17.833 12.832 17.833H5.33203ZM23.749 7.33301C22.644 7.33302 21.5841 7.77232 20.8027 8.55371C20.0214 9.33511 19.582 10.395 19.582 11.5C19.582 12.605 20.0214 13.6649 20.8027 14.4463C21.5841 15.2277 22.644 15.667 23.749 15.667C24.8541 15.667 25.9139 15.2277 26.6953 14.4463C27.4767 13.6649 27.916 12.6051 27.916 11.5C27.916 10.3949 27.4767 9.33511 26.6953 8.55371C25.9139 7.77232 24.8541 7.33301 23.749 7.33301ZM5.33203 12.833C4.66549 12.8331 4.16602 13.3334 4.16602 14C4.16603 14.6666 4.66551 15.1669 5.33203 15.167H9.08203C9.74869 15.167 10.249 14.6667 10.249 14C10.249 13.3333 9.7487 12.833 9.08203 12.833H5.33203ZM5.33203 7.83301C4.66549 7.83314 4.16602 8.33342 4.16602 9C4.16603 9.66656 4.66551 10.1669 5.33203 10.167H12.832C13.4987 10.167 13.999 9.66665 13.999 9C13.999 8.33333 13.4987 7.83301 12.832 7.83301H5.33203Z" fill="url(#paint0_linear_5187_8249)"/>
  <defs>
    <linearGradient id="paint0_linear_5187_8249" x1="0.332031" y1="14" x2="33.666" y2="14" gradientUnits="userSpaceOnUse">
      <stop stop-color="#62AFFF"/>
      <stop offset="1" stop-color="#9C41FF"/>
    </linearGradient>
  </defs>
</svg>
					</div>
					<el-radio :label="1" class="auth-option hide-radio-dot">
						<div class="option-text">
							<h4>营业执照认证</h4>
							<p>上传纸质营业执照原件图片</p>
						</div>
					</el-radio>
				</div>
				<div
					style="background-color: white;display: flex;align-items: center;border-radius: 10px;margin-top: 15px;">
					<div class="option-icon">
						<img src="./assets/img/123.png" alt="邀请码认证" />
					</div>
					<el-radio :label="2" class="auth-option hide-radio-dot">
						<div class="option-text">
							<h4>邀请码认证</h4>
							<p>输入官方发放的邀请码</p>
						</div>
					</el-radio>
				</div>
<!-- 				<div
					style="background-color: white;display: flex;align-items: center;border-radius: 10px;margin-top: 15px;">
					<div class="option-icon">
						<img src="https://picsum.photos/30/30" alt="电子营业执照" />
					</div>
					<el-radio :label="2" class="auth-option hide-radio-dot">
						<div class="option-text">
							<h4>电子营业执照认证</h4>
							<p>跳转至微信小程序授权</p>
						</div>
					</el-radio>
				</div>
				<div
					style="background-color: white;display: flex;align-items: center;border-radius: 10px;margin-top: 15px;">
					<div class="option-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M4.85156 32.8672C4.85156 33.6406 5.46875 34.2695 6.23047 34.2695H22.9453C21.9844 32.9609 21.4688 31.3828 21.4727 29.7578C21.4727 26.3438 23.7031 23.457 26.7578 22.5156C25.6484 21.7266 24.4375 21.1094 23.1602 20.6836C23.1719 20.6797 23.1797 20.6719 23.1914 20.668C25.9453 19.0352 27.6328 16.0664 27.6211 12.8672C27.6211 9.65234 25.9297 6.67578 23.1914 5.06641C21.9375 4.32812 20.5469 3.92969 19.1445 3.86719H18.375C16.9727 3.92969 15.582 4.32812 14.3281 5.06641C11.5742 6.69922 9.89062 9.66406 9.89844 12.8672C9.89844 16.0859 11.5859 19.0586 14.3281 20.668C14.3398 20.6758 14.3516 20.6797 14.3594 20.6875C9.25 22.4062 5.44922 27.0391 4.86328 32.6562C4.85547 32.707 4.84766 32.7539 4.84766 32.8086V32.8672H4.85156Z" fill="url(#paint0_linear_5187_8282)"/>
  <path d="M28.918 23.2969C25.4102 23.2969 22.5625 26.1914 22.5625 29.7617C22.5547 32.0586 23.7657 34.1875 25.7422 35.3594C27.7032 36.5117 30.1368 36.5117 32.0977 35.3594C34.0743 34.1875 35.2852 32.0586 35.2774 29.7617C35.2735 26.1914 32.4258 23.2969 28.918 23.2969ZM32.9297 28.9062L28.8047 33.0977L28.7735 33.1289L28.7227 33.1797C28.4649 33.4453 28.1133 33.5937 27.7461 33.5937C27.3789 33.5937 27.0235 33.4453 26.7696 33.1797L24.9102 31.2891C24.3672 30.7383 24.3672 29.8516 24.9102 29.3008C25.168 29.0391 25.5196 28.8906 25.8868 28.8906C26.2539 28.8906 26.6055 29.0391 26.8633 29.3008L27.7461 30.1992L30.9766 26.918C31.2344 26.6523 31.586 26.5039 31.9532 26.5039C32.3203 26.5039 32.6758 26.6523 32.9297 26.918C33.4688 27.4687 33.4688 28.3516 32.9297 28.9062Z" fill="url(#paint1_linear_5187_8282)"/>
  <defs>
    <linearGradient id="paint0_linear_5187_8282" x1="4.84766" y1="19.0684" x2="27.6212" y2="19.0684" gradientUnits="userSpaceOnUse">
      <stop stop-color="#62AFFF"/>
      <stop offset="1" stop-color="#9C41FF"/>
    </linearGradient>
    <linearGradient id="paint1_linear_5187_8282" x1="22.5625" y1="29.7603" x2="35.2774" y2="29.7603" gradientUnits="userSpaceOnUse">
      <stop stop-color="#62AFFF"/>
      <stop offset="1" stop-color="#9C41FF"/>
    </linearGradient>
  </defs>
</svg>
					</div>
					<el-radio :label="3" class="auth-option hide-radio-dot">
						<div class="option-text">
							<h4>在职证明认证</h4>
							<p>上传加盖公章的在职证明</p>
						</div>
					</el-radio>
				</div>
				<div
					style="background-color: white;display: flex;align-items: center;border-radius: 10px;margin-top: 15px;">
					<div class="option-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M35.2687 33.0872H4.73202C3.5277 33.0872 2.55078 32.1103 2.55078 30.9062V9.09408C2.55078 7.88976 3.5277 6.91284 4.73202 6.91284H35.2687C36.473 6.91284 37.4499 7.88976 37.4499 9.09408V30.9062C37.4499 32.1103 36.473 33.0872 35.2687 33.0872ZM32.8235 11.538C32.3989 11.1119 31.7073 11.1119 31.2813 11.538L22.1816 20.5966V20.5838C21.5937 21.1446 20.8083 21.4997 19.9323 21.4997C19.1157 21.4997 18.3929 21.1704 17.8193 20.6761L8.71814 11.538C8.29202 11.1119 7.60194 11.1119 7.17586 11.538C6.74974 11.9641 6.74974 12.6541 7.17586 13.08L14.0759 20.0186L7.17586 26.9184C6.74978 27.3445 6.74978 28.0348 7.17586 28.4607C7.60194 28.8868 8.29338 28.8868 8.71814 28.4607L15.6137 21.5662L17.4172 23.3784C17.5062 23.4804 17.6016 23.5767 17.7027 23.6667L17.8192 23.7618C18.3815 24.2163 19.0859 24.4989 19.8639 24.4989C20.7701 24.4989 21.5893 24.2019 22.1815 23.607L24.2817 21.5295L31.213 28.4608C31.6391 28.8867 32.3307 28.8867 32.7553 28.4608C33.1812 28.0349 33.1812 27.3446 32.7553 26.9185L25.8325 19.9958L32.8235 13.0801C33.2495 12.6542 33.2495 11.9641 32.8235 11.538Z" fill="url(#paint0_linear_5187_8294)"/>
  <defs>
    <linearGradient id="paint0_linear_5187_8294" x1="2.55078" y1="20" x2="37.4499" y2="20" gradientUnits="userSpaceOnUse">
      <stop stop-color="#62AFFF"/>
      <stop offset="1" stop-color="#9C41FF"/>
    </linearGradient>
  </defs>
</svg>
					</div>
					<el-radio :label="4" class="auth-option hide-radio-dot">
						<div class="option-text">
							<h4>企业邮箱认证</h4>
							<p>使用公司邮箱接收验证码</p>
						</div>
					</el-radio>
				</div>
				<div
					style="background-color: white;display: flex;align-items: center;border-radius: 10px;margin-top: 15px;">
					<div class="option-icon">
						<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <path d="M19.3075 1.45996C19.5127 1.32345 19.7536 1.25061 20 1.25061C20.2464 1.25061 20.4874 1.32345 20.6925 1.45996C25.4425 4.62496 30.1225 5.79496 34.7925 5.01746C34.9717 4.9873 35.1553 4.99657 35.3305 5.04461C35.5057 5.09265 35.6684 5.17832 35.8071 5.29564C35.9459 5.41296 36.0574 5.55912 36.1339 5.72394C36.2103 5.88876 36.25 6.06827 36.25 6.24996V23.82C36.2499 25.9094 35.668 27.9575 34.5694 29.7348C33.4708 31.512 31.8989 32.9483 30.03 33.8825L20.56 38.6175C20.3862 38.7046 20.1944 38.7499 20 38.7499C19.8056 38.7499 19.6138 38.7046 19.44 38.6175L9.97 33.8825C8.10106 32.9483 6.52922 31.512 5.43062 29.7348C4.33202 27.9575 3.75007 25.9094 3.75 23.82V6.24996C3.75008 6.06852 3.78967 5.88926 3.86601 5.72465C3.94235 5.56004 4.05361 5.41402 4.19206 5.29674C4.33051 5.17946 4.49284 5.09373 4.66776 5.0455C4.84268 4.99727 5.02601 4.98771 5.205 5.01746C9.8775 5.79496 14.56 4.62496 19.305 1.45996H19.3075ZM20 7.49996C18.7351 7.50109 17.5004 7.88596 16.4589 8.60373C15.4174 9.32149 14.6182 10.3384 14.1669 11.52C13.7156 12.7016 13.6334 13.9923 13.9313 15.2216C14.2291 16.4509 14.8929 17.5609 15.835 18.405C14.0934 19.2028 12.6177 20.4841 11.5833 22.0965C10.5488 23.7088 9.9993 25.5843 10 27.5C10 27.8315 10.1317 28.1494 10.3661 28.3838C10.6005 28.6183 10.9185 28.75 11.25 28.75C11.5815 28.75 11.8995 28.6183 12.1339 28.3838C12.3683 28.1494 12.5 27.8315 12.5 27.5C12.5 25.5108 13.2902 23.6032 14.6967 22.1967C16.1032 20.7901 18.0109 20 20 20C21.9891 20 23.8968 20.7901 25.3033 22.1967C26.7098 23.6032 27.5 25.5108 27.5 27.5C27.5 27.8315 27.6317 28.1494 27.8661 28.3838C28.1005 28.6183 28.4185 28.75 28.75 28.75C29.0815 28.75 29.3995 28.6183 29.6339 28.3838C29.8683 28.1494 30 27.8315 30 27.5C30.0004 25.585 29.4506 23.7103 28.4162 22.0989C27.3818 20.4874 25.9062 19.207 24.165 18.41C25.1089 17.5663 25.7744 16.4559 26.0733 15.2257C26.3722 13.9956 26.2905 12.7036 25.839 11.5209C25.3875 10.3382 24.5875 9.32043 23.5448 8.60242C22.5021 7.8844 21.266 7.49996 20 7.49996ZM20 9.99996C20.4925 9.99996 20.9801 10.097 21.4351 10.2854C21.89 10.4739 22.3034 10.7501 22.6517 11.0983C22.9999 11.4465 23.2761 11.8599 23.4645 12.3149C23.653 12.7699 23.75 13.2575 23.75 13.75C23.75 14.2424 23.653 14.7301 23.4645 15.185C23.2761 15.64 22.9999 16.0534 22.6517 16.4016C22.3034 16.7498 21.89 17.0261 21.4351 17.2145C20.9801 17.403 20.4925 17.5 20 17.5C19.0054 17.5 18.0516 17.1049 17.3483 16.4016C16.6451 15.6984 16.25 14.7445 16.25 13.75C16.25 12.7554 16.6451 11.8016 17.3483 11.0983C18.0516 10.3951 19.0054 9.99996 20 9.99996Z" fill="url(#paint0_linear_5187_8304)"/>
  <defs>
    <linearGradient id="paint0_linear_5187_8304" x1="3.75" y1="20.0003" x2="36.25" y2="20.0003" gradientUnits="userSpaceOnUse">
      <stop stop-color="#62AFFF"/>
      <stop offset="1" stop-color="#9C41FF"/>
    </linearGradient>
  </defs>
</svg>
					</div>
					<el-radio :label="5" class="auth-option hide-radio-dot">
						<div class="option-text">
							<h4>社保缴存认证</h4>
							<p>验证社保缴存信息</p>
						</div>
					</el-radio>
				</div> -->
			</el-radio-group>
			<!-- 编辑公司名称（远程搜索）对话框 -->
			<el-dialog title="编辑公司名称" :visible.sync="companyDialogVisible" width="520px" append-to-body class="company-dialog">
				<div class="company-dialog-body">
					<div class="company-dialog-label">公司名称</div>
					<el-select v-model="companySelect"
					filterable
					remote
					reserve-keyword
					placeholder="请输入公司名称搜索"
					:remote-method="remoteSearchCompanies"
					:loading="companyLoading"
						style="width: 100%;">
					<el-option v-for="item in companyOptions" :key="item.company_name" :label="item.company_name"
						:value="item.company_name" />
					</el-select>
				</div>
				<span slot="footer" class="dialog-footer company-dialog-footer">
					<el-button class="btn-cancel" @click="companyDialogVisible = false">取 消</el-button>
					<el-button class="btn-confirm" type="primary" @click="confirmCompanySelect">确 定</el-button>
				</span>
			</el-dialog>
			<el-button class="next-btn" type="primary" @click="handleNext" :disabled="!selectedAuth">下一步
			</el-button>
		</div>
	</div>
</template>
<script>
	import {
		getCertification
	} from '@/api/businessVerificationFunc'
	import { getQuery } from '@/api/businessVerification'
	export default {
		data() {
			return {
				form: {},
				companyName: '',
				selectedAuth: null, // 绑定选中的认证方式
				companyDialogVisible: false,
				companySelect: '',
				companyOptions: [],
				companyLoading: false,
			};
		},
		created() {
			this.form = JSON.parse(this.$route.query.form)
			this.companyName = this.form.company_name
		},
		methods: {
			open() {
				// 打开远程搜索选择对话框
				this.companySelect = this.companyName || ''
				this.companyOptions = []
				this.companyDialogVisible = true
			},
			remoteSearchCompanies(query) {
				if (!query) {
					this.companyOptions = []
					return
				}
				this.companyLoading = true
				getQuery({ name: query }).then(res => {
					if (res.data && res.data.code == 1) {
						this.companyOptions = (res.data.data || []).filter(item =>
							(item.company_name || '').toLowerCase().includes(query.toLowerCase())
						)
					}
				}).finally(() => {
					this.companyLoading = false
				})
			},
			confirmCompanySelect() {
				if (!this.companySelect) {
					this.$message.warning('请先选择公司')
					return
				}
				// 可选：调用 getCertification 进行校验
				getCertification({ company_name: this.companySelect }).then(res => {
					if (res.data && (res.data.code === 200 || res.data.code === 1)) {
						this.companyName = this.companySelect
						this.form.company_name = this.companySelect
						this.companyDialogVisible = false
					} else {
						this.$message.info('您选择的公司未通过校验')
					}
				}).catch(() => {
					this.$message.info('公司校验失败')
				})
			},
			closeDialog() {
				// 关闭逻辑，如关闭弹窗等
				console.log("关闭企业认证");
			},
			handleNext() {
				// 下一步逻辑，根据 selectedAuth 进行对应操作
				console.log("选择的认证方式：", this.selectedAuth);
				if (this.selectedAuth == 1) {
					this.$router.push({
						path: '/verifyCompany/businessLicense',
						query: {
							form: JSON.stringify(this.form),
						}
					})

				} else if (this.selectedAuth == 2) {
					console.log('跳转到邀请码认证页面');
					this.$router.push({
						path: '/verifyCompany/invitationCode',
						query: {
							form: JSON.stringify(this.form),
						}
					});
				} else if (this.selectedAuth == 3) {
					this.$router.push({
						path: '/verifyCompany/onTheJob',
						query: {
							form: JSON.stringify(this.form),
						}
					});
					
				} else if (this.selectedAuth == 4) {
					this.$router.push({
						path: '/verifyCompany/email',
						query: {
							form: JSON.stringify(this.form),
						}
					});
				} else {
					this.$router.push({
						path: '/verifyCompany/socialInsurance/verify',
						query: {
							form: JSON.stringify(this.form),
						}
					});
				}
			},
		},
	};
</script>
<style scoped lang="css" src="./assets/index.css" />
<style scoped>
	::v-deep .el-input-group__append {
		border-radius: 0px 18px 18px 0px;
		font-size: large;
	}

	::v-deep .el-input-group__prepend {
		border-radius: 18px 0px 0px 18px;
		font-size: x-large;
	}

	::v-deep .el-input__inner {
		height: 60px;
		font-size: large;
		border-radius: 18px;
	}

	::v-deep .phone .el-input__inner {
		border-radius: 0px;
	}

	.auth-page {
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #f0f2f5;
	}

	.auth-card {
		width: 400px;
		border-radius: 12px;
		overflow: hidden;
	}

	.card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: linear-gradient(to right, #8cb4fc, #b273fa);
		color: #fff;
		padding: 15px 20px;
	}

	.card-header span {
		font-size: 18px;
		font-weight: bold;
	}

	.close-btn {
		color: #fff;
	}

	.auth-content {
		margin: 100px 20px 40px 20px;
	}

	.tip-text {
		font-size: 14px;
		color: #606266;
		margin-top: 40px;
	}

	.company-info {
		font-size: 14px;
		margin-bottom: 20px;
	}

	.auth-option {
		display: flex;
		flex-direction: row;
		align-items: center;
		padding: 8px 0;
		border-bottom: 1px solid #ebeef5;
		cursor: pointer;
	}

	.option-icon {
		margin-right: 12px;
		margin-left: 20px;
	}

	.option-icon img {
		width: 30px;
		height: 30px;
		border-radius: 4px;
	}

	.option-text h4 {
		font-size: 16px;
		font-weight: bold;
		margin-bottom: 4px;
	}

	.option-text p {
		font-size: 12px;
		color: #909399;
	}

	.next-btn {
		width: 100%;
		margin-top: 20px;
		background: linear-gradient(to right, #8cb4fc, #b273fa);
		border: none;
	}

	.next-btn:hover {
		background: linear-gradient(to right, #7ca9f7, #a863f7);
	}

	/* 隐藏第五个radio的圆点 */
	::v-deep .hide-radio-dot .el-radio__inner {
		display: none;
	}

/* 公司对话框美化 */
.company-dialog :deep(.el-dialog__header) {
    border-bottom: 1px solid #f0f0f0;
    padding: 14px 20px;
}
.company-dialog :deep(.el-dialog__title) {
    font-size: 16px;
    font-weight: 600;
}
.company-dialog :deep(.el-dialog__body) {
    padding: 20px;
}
.company-dialog-body {
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.company-dialog-label {
    font-size: 14px;
    color: #606266;
}
.company-dialog :deep(.el-select .el-input__inner) {
    height: 44px;
    border-radius: 8px;
}
.company-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}
.btn-cancel {
    border-radius: 8px;
}
.btn-confirm {
    border-radius: 8px;
    background: linear-gradient(90deg, #62AFFF 0%, #9C41FF 100%);
    border: none;
}
</style>